import axios from "axios";
import { APIURL } from "./util/constant";

const instance = axios.create();

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    let lang = localStorage.getItem("i18nextLng");

    if (!lang) {
      lang = "tr-TR";
    }

    //config.baseURL = "https://fga-portal-api-dev.genbil.com/";
    config.baseURL = APIURL;

    // config.baseURL = "http://localhost:3001";
    config.headers["Authorization"] = `Bearer ${token}`;
    config.headers["Accept-Language"] = lang;

    const blobPaths = [
      "api/file/get/",
      "api/certification/get/",
      "api/organization/export-my-team",
      "api/training/export-potential-trainings",
      "api/training/export-all-registered-trainings",
      "api/invoice/export-invoice",
      "api/applicant-pool/export-approved-applicant-pool-mtal",
      "api/applicant-pool/export-approved-applicant-pool",
      "api/employee-360/export-training-scores",
    ];

    if (blobPaths.some((z) => config.url.indexOf(z) > -1))
      config.responseType = "blob";

    return config;
  },
  (error) => {
    // console.dir(error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // console.dir(response.headers);
    return response;
  },
  function (error) {
    // TODO : remove
    // console.log("Response Error : " + error);
    return Promise.reject(error);
  }
);

export const api = instance;
